/**
 * home.tsx
 * 
 * @copyright jnakaso.com
 * 
 *  home page
 * 
 */

import { Card, Center, Flex, Group, Stack, Text } from "@mantine/core";
import { useContext, useEffect, useState } from "react";
import Markdown from "react-markdown";
import { GoyLeaderboardCard } from "src/components/cards/goyCard";
import QualifierCard from "src/components/cards/qualifierCard";
import TournamentCard from "src/components/cards/tournamentCard";
import { SettingsContext } from "src/components/contexts";
import { storageService } from "src/services/storageService";
import { tournamentService } from "src/services/tournamentService";
import { Tournament } from "src/types/tournament";


// function EventCard(props: { event: any }) {
//     return <Card padding="lg" radius="md" withBorder style={
//         {
//             marginLeft: '2rem',
//             marginBottom: '2rem',
//             backgroundColor: 'rgba(0, 0, 0, 0.25)'
//         }}>
//         <Card.Section>
//             <Center bg="var(--mantine-color-gray-light)">
//                 <Text className="hero-sm">Next Up</Text>
//             </Center>
//         </Card.Section>

//         <Text className="hero-sm">Date: {props.event.date}</Text>
//         <Text className="hero-sm">Course: {props.event.location}</Text>
//         <Text className="hero-sm">Time: {props.event.time}</Text>
//         <Text className="hero-sm">{props.event.note}</Text>
//     </Card>
// }

function AnnouncementCard(props: { file: string }) {

    const [text, setText] = useState('No content found');

    useEffect(() => {
        storageService.getInfoFile(props.file)
            .then((text) => setText(text))
            .catch((e) => console.error(e));
    }, [props])

    return <Card padding="lg" radius="md" withBorder style={
        {
            marginLeft: '2rem',
            marginBottom: '2rem',
            backgroundColor: 'rgba(0, 0, 0, 0.75)'
        }}>
        <Card.Section>
            <Center bg="var(--mantine-color-gray-light)">
                <Markdown className="announcements">{text}</Markdown>
            </Center>
        </Card.Section>
    </Card>
}

function Home() {
    const { settings } = useContext(SettingsContext);
    // const [event, setEvent] = useState<any>({});
    const [standings, setStandings] = useState<any>([]);
    const [qualifiers, setQualifiers] = useState<any>([]);
    const [season, setSeason] = useState(new Date().getFullYear());
    const [tournament, setTournament] = useState<Tournament | undefined>();

    useEffect(() => {
        if (settings) {
            setSeason(settings.season);
            storageService.getSeasonFile(settings.season, 'goy.json')
                .then(t => setStandings(JSON.parse(t)))
                .catch(err => console.error('cannot load goy', err));
            storageService.getSeasonFile(settings.season, 'qualifiers.json')
                .then(t => setQualifiers(JSON.parse(t)))
                .catch(err => console.error('cannot load qualifiers', err));
            tournamentService.getLast()
                .then(t => setTournament(t!))
                .catch(err => console.error('cannot load last tournament', err));
        }
    }, [settings])

    return (
        <Stack>
            <Stack style={{
                backgroundImage: `url(rainier.jpg)`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}>
                <Center style={{ padding: '1rem', backgroundColor: 'rgba(0, 0, 0, 0.25)' }}>
                    <Text className="hero-lg" >Puget Sound Golf Club</Text>
                </Center>
                <Flex>
                    <AnnouncementCard file={'announcements.md'} />
                </Flex>
            </Stack>
            <Group w="100%">
                <Flex
                    direction={{ base: 'column', sm: 'row' }}
                    gap={{ base: 'sm', sm: 'lg' }}
                    justify={{ sm: 'center' }}>
                    <Stack maw="20rem" miw="20rem">
                        <GoyLeaderboardCard season={season} standings={standings} maxRows={5} />
                        <QualifierCard season={season} qualifiers={qualifiers} />
                    </Stack>
                    <Stack >
                        <TournamentCard tournament={tournament} title="Recent: " />
                    </Stack>
                </Flex>
            </Group>
        </Stack>
    );

}

export default Home;